import React, { Component } from 'react';
import { FLOW_TYPE, REDIRECT_SUFFIX } from '../../../framework/App/AppConstants';
import { trackTransition } from '../../../framework/store/FPTI/FPTIActions';
import { PPC_STATUS } from '../../config/GBConstants';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import { connect } from 'react-redux';
import RedirectButton from '../../../shared-components/RedirectButton/RedirectButton';
import StickyFooter from '../../../shared-components/StickyFooter/StickyFooter';
import '../../styles/base-gb.less';
import PageHeaderText from '../../../shared-components/Typography/PageHeaderText';

const LOCALE_PREFIX = 'GB/pages/IneligibilityPage/IneligibilityPage';

export class IneligibilityPage extends Component {
    static propTypes = {
        flow: PropTypes.oneOf(Object.values(FLOW_TYPE)),
        eligibilityDeclineMessage: PropTypes.string,
        intl: intlShape.isRequired,
        onComponentDidMount: PropTypes.func.isRequired
    };
    static defaultProps = {
        onComponentDidMount: () => {}
    };

    componentDidMount() {
        this.props.onComponentDidMount();
    }

    render() {
        const { intl, flow, eligibilityDeclineMessage } = this.props;
        const messageHeader = intl.formatMessage({ id: `${LOCALE_PREFIX}.${eligibilityDeclineMessage}.headerMessage` });
        const messagePara = intl.formatMessage({ id: `${LOCALE_PREFIX}.${eligibilityDeclineMessage}.messagePara` });
        const continueText = intl.formatMessage({ id: `${LOCALE_PREFIX}.continue` });

        return (
            <div>
                <div className="outerWrapper gb-wrapper">
                    <div id="wrapper">
                        <div id="main">
                            <Header singleColumnLayout={true} displayLogout={(flow === FLOW_TYPE.DIRECT_APP)} />
                            <section id="IneligibilityPage" className="contentSection">
                                <div className="row-fluid container">
                                    <span className="span24">
                                        <PageHeaderText>{messageHeader}</PageHeaderText>
                                        <p>{messagePara}</p>
                                        <div className="row-fluid">
                                            <span className="span14">
                                                <div className="buttons">
                                                    <RedirectButton
                                                        ctaLabel={continueText}
                                                        buttonId="ineligibleContinue"
                                                        actionUri={REDIRECT_SUFFIX.RETURN_REDIRECT}
                                                    />
                                                </div>
                                            </span>
                                        </div>
                                    </span>
                                </div>
                            </section>
                        </div>
                    </div>
                    <StickyFooter fixToBottom={true} fadedBackground={true}>
                        <Footer showCancelUrl={false} />
                    </StickyFooter>
                </div>
            </div>
        );
    }
}

export const mapStateToProps = state => ({
    flow: state.serverData.flow,
    eligibilityDeclineMessage: state.serverData.eligibilityDeclineMessage
});

export const mapDispatchToProps = dispatch => ({
    onComponentDidMount() {
        dispatch(trackTransition(
            'pp_credit_ineligiblepage',
            'prepare_pp_credit_ineligiblepage',
            { ppc_status: PPC_STATUS.INELIGIBLE }
        ));
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(IneligibilityPage));
